import { render, staticRenderFns } from "./editStudent.vue?vue&type=template&id=6380ba3c&"
import script from "./editStudent.vue?vue&type=script&lang=js&"
export * from "./editStudent.vue?vue&type=script&lang=js&"
import style0 from "./editStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports